import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import cn from 'classnames';
import styles from './NavbarBox.module.scss';
import NavItem from '../../NavItem/NavItem';
import LanguageBox from '../LanguageBox/LanguageBox';
import { useTranslation } from 'react-i18next';
import LanguageMenu from '../../LanguageMenu/LanguageMenu';
import useComponentVisible from '../../../hooks/useComponentVisible';
import { getMenuItemsByLocation } from '../../../system/utils/menuUtils';
import { MENU_LOCATIONS, menuConfig } from '../../../system/menuConfig';
const NavbarBox = () => {
    const { t } = useTranslation();
    const { ref, refTarget, isComponentVisible, setIsComponentVisible } = useComponentVisible(false);
    const headerMenuItems = getMenuItemsByLocation(menuConfig, MENU_LOCATIONS.HEADER);
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ className: cn(styles.element, 'd-flex position-relative') }, { children: [headerMenuItems.map(({ title, href, disabled, isExternal, target }, index) => {
                    return (_jsx(NavItem, { href: href, target: target, isExternal: isExternal, line: true, title: t(`${title}`), disabled: disabled }, index));
                }), _jsxs("div", Object.assign({ className: 'position-relative d-flex' }, { children: [_jsx(LanguageBox, { refTarget: refTarget, onClick: () => setIsComponentVisible(!isComponentVisible), isComponentVisible: isComponentVisible }), isComponentVisible && (_jsx(LanguageMenu, { innerRef: ref, closeModal: () => setIsComponentVisible(false) }))] }))] })) }));
};
export default NavbarBox;
